import * as hooks from "./directive/index" //指令
import router from "../router"
export default {
    install(Vue) {
        Object.keys(hooks).forEach(item => {
            Vue.directive(item, hooks[item])
        })
        Vue.mixin({
            methods: {
                handleGo(val) {
                    router.push(val)
                }
            }
        })
    }
}